import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  
  html {
    --color-white: white;
    --color-black: black;
    --color-grey-1: #111111;
    --color-grey-2: #222222;
    --color-grey-3: #333333;
    --color-grey-7: #777777;
    --color-magenta: #FF00AC;
    --color-fluor-purple: #6D13FE;
    --color-fluor-green: #9AFF00;
    --color-fluor-orange: #FF6D00;
    --color-builder-menu-primary: var(--color-fluor-orange);
    --font-primary: 'NB Grotesk', sans-serif;
    
    --z-index-nav-dropdown: 10;
    --z-index-high: 1000;
    --z-index-low: 1;

    color: var(--color-black);
    font-size: 16px;
    font-family: var(--font-primary);
  }

  html, body, #___gatsby ,#gatsby-focus-wrapper, main {
    height: 100%;
  }

  fieldset {
    border: 0;
    padding: 0;
    margin: 0;
    min-width: 0;
  }

  a {
    color: var(--color-fluor-orange)
  }
`;
